import { MatchParams as ChainMatchParams } from '@/pages/Chain/types';
import { MatchParams as ModelMatchParams } from '@/pages/Model/types';
import { MatchParams as SharedEndpointMatchParams } from '@/pages/SharedEndpoint/types';
import { MatchParams as TrainingProjectMatchParams } from '@/pages/Training/types';

import {
  ChainsTableChainFragment,
  ModelsTableModelFragment,
  OrgSharedEndpointsTableFragment,
} from './__generated__/fragments.generated';

// TODO: This should really be joined by `|`.
type MatchParams = ModelMatchParams &
  ChainMatchParams &
  SharedEndpointMatchParams &
  TrainingProjectMatchParams;

enum TabsEnum {
  Overview = 'overview',
  Logs = 'logs',
  Metrics = 'metrics',
  Activity = 'activity',
  Environments = 'environments',
  ManageInstaceType = 'manage-instance-type',
}

enum FilterMode {
  ALL = 'All',
  RUNNING = 'Running',
  SCALED_TO_ZERO = 'Scaled to zero',
  INACTIVE = 'Inactive',
  FAILED = 'Failed',
}

enum ViewMode {
  List = 'list',
  Grid = 'grid',
}

enum TableDeploymentStatus {
  Running = 'Running',
  InProgress = 'InProgress',
  ScaledToZero = 'ScaledToZero',
  Unhealthy = 'Unhealthy',
  Failed = 'Failed',
  Other = 'Other',
}

enum ActivateModelCheckResult {
  CanActivate,
  NeedsPaymentMethod,
  PaymentMethodFailed,
}

type PromotionDetails = {
  percentageTraffic: number;
  rampUpDurationSeconds: number;
  rollingDeploy: boolean;
  rollingDeployTargetScale: number;
  rampUpStartedAt: Date;
};

type Entity = ModelsTableModelFragment | ChainsTableChainFragment | OrgSharedEndpointsTableFragment;

export { TabsEnum, ActivateModelCheckResult, FilterMode, TableDeploymentStatus, ViewMode };
export type { PromotionDetails, MatchParams, Entity };
